import cx from 'classnames';
import * as React from 'react';
import View from 'components/View';
import './styles/SyncSetupView.scss';

type Props = {
  children?: React.ReactNode;
  className?: string;
};

export default function SyncSetupView(props: Props) {
  const { children, className } = props;

  return (
    <View scroll className={cx('SyncSetupView', className)}>
      {children}
    </View>
  );
}
